import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { FilterSelected, FilterTag } from '@scalefast/core';

@Component({
  selector: 'app-filter-tags',
  templateUrl: './filter-tags.component.html',
  styleUrls: ['./filter-tags.component.scss'],
  standalone: true,
})
export class AppFilterTagsComponent implements OnChanges {
  @Input() values: Array<FilterTag> | undefined;
  @Output() tagEvent = new EventEmitter<FilterTag>();
  @Output() removeAllTagsEvent = new EventEmitter();

  tagsValues: FilterTag[] | undefined;
  tagsArray: FilterTag[] = [];

  ngOnChanges() {
    if (this.values) {
      if (Object.keys(this.values).length > 0) {
        this.updateOrAdd(this.values, this.tagsArray);
      } else {
        this.values = [];
      }
    }
  }

  updateOrAdd(newObjects: FilterTag[], originalArray: FilterTag[]) {
    newObjects.forEach((newObj) => {
      const { name } = newObj;
      const index = originalArray.findIndex((el) => el.name === name);
      if (index !== -1) {
        originalArray[index] = newObj;
      } else {
        originalArray.push(newObj);
      }
    });
  }

  removeTag(tag: FilterTag, value: string) {
    const filteredTags = tag.values.filter((t: FilterSelected) => t.value !== value);
    tag.values = filteredTags;

    this.tagEvent.emit(tag);
  }

  removeAllTags() {
    this.tagsArray = [];
    this.removeAllTagsEvent.emit();
  }

  get showDeleteAllTags() {
    return this.tagsArray.some((tagArray: FilterTag) => tagArray.values.length > 0 && tagArray.name != 'sort');
  }
}
